import React from 'react';
import { useSecurity } from '../../Contexts/SecurityContext';
import { Permissions } from '../../Security/permissions';
import { Tab, Row, Col, Nav } from 'react-bootstrap';
import AppLogoConfiguration from './AppLogoConfiguration';
import ReportsManagement from './ReportsManagement';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '../../authConfig';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { PageLayout2 } from '../../Components/PageLayout/PageLayout2';
import AdvancedConfiguration from './AdvancedConfiguration';
import './GeneralConfigurationTabs.scss';


const GeneralConfigurationsContent = () => {
    const { hasPermission } = useSecurity();
    const canViewReports = hasPermission(Permissions.Reports.Dashboards);
    return (
        <div className='general-configuration-tabs'>
            <Tab.Container defaultActiveKey="app-logo">
            <Row className='w-100'>
                <Col sm={3} className='h-100'>
                    <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                            <Nav.Link eventKey="app-logo">App Logo Configuration</Nav.Link>
                        </Nav.Item>
                        {canViewReports && <Nav.Item>
                            <Nav.Link eventKey="reports-management">Reports Management</Nav.Link>
                        </Nav.Item>}
                        <Nav.Item>
                            <Nav.Link eventKey="tasks-config">Advanced Configuration</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
                <Col sm={9} className='h-100'>
                    <Tab.Content className='w-100 h-100'>
                        <Tab.Pane eventKey="app-logo" className='h-100'>
                            <AppLogoConfiguration />
                        </Tab.Pane>
                        <Tab.Pane eventKey="reports-management" className='h-100'>
                            {canViewReports && <ReportsManagement />}
                        </Tab.Pane>
                        <Tab.Pane eventKey="tasks-config" className='h-100'>
                            <AdvancedConfiguration />
                        </Tab.Pane>
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
        </div>
    );
};

const GeneralConfigurationsPage = () => {
    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <PageLayout2 title="Portal Configurations">
                <GeneralConfigurationsContent />
            </PageLayout2>
        </MsalAuthenticationTemplate>
    );
};

export default GeneralConfigurationsPage;
